import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface DeleteThirdPartyPayoffRowRequest {
    engagementId: number;
    tableRowId: number;
}

export const DeleteThirdPartyPayoffRow = createAsyncThunk(
    'flowOfFunds/deleteThirdPartyPayoffRow',
    async (params: DeleteThirdPartyPayoffRowRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.delete(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to delete the pay-off row');
            }

            return params.tableRowId;
        } catch (error) {
            createNotification('Could not delete the pay-off row.', 'error');
            throw error;
        }
    }
);
